import './style.sass';
import { Form, Formik } from 'formik';
import React from 'react';
import { InputGroup } from '../common/InputGroup';
import { SearchData, campaignSearchValidationSchema } from 'app/viewModels/pages/CampaignsPageViewModel';
import { ReactSVG } from 'react-svg';
import searchIcon from 'assets/img/icons/searchIcon.svg';

type Props = {
    onSubmit: (searchString: string) => void,
};

const initialValues = {
    searchOrder: '',
};


export const CampaignsSearch = ({ onSubmit }: Props) => {

    const onSubmitForm = (data: SearchData) => {
        if (onSubmit) {
            onSubmit(data.searchOrder);
        }
    };

    return (
        <div className="campaigns-search">
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmitForm}
                validationSchema={campaignSearchValidationSchema}
            >
                <Form className="campaigns-search__form">
                    <ReactSVG src={searchIcon} className="campaigns-search__icon"/>

                    <InputGroup
                        id="searchOrder"
                        name="searchOrder"
                        type="text"
                        placeholder="I’m looking for order..."
                        autoComplete="off"
                    />

                    <button type="submit" className="campaigns-search__btn">
                        <span className="p2-medium violet-text">Search</span>
                    </button>
                </Form>
            </Formik>
        </div>
    );
};
